/** Shared hover delay before any cell tooltip opens, in milliseconds. */
export const TOOLTIP_OPEN_DELAY = 500;
